import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';

import { tpoGenUrls } from 'config/urls';
import { sendNotification } from 'utils/helperMethods';

import { tpoGenKeys } from '../../../utils/tpoGenQueryKeys';
import type { UpdatePromoLibraryKpiRequest, UpdatePromoLibraryKpiResponse } from '../../types';

const updateKpi = async (body: UpdatePromoLibraryKpiRequest): Promise<UpdatePromoLibraryKpiResponse> => {
    let token = '';
    try {
        token = localStorage.getItem('accessToken') ?? '';
    } catch {
        // incognito / disabled storage
    }

    const response = await axios(tpoGenUrls.updatePromoLibrary, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}` },
        data: body,
    });
    return response.data;
};

interface UseUpdatePromoLibraryKpiMutationOptions {
    onSuccess?: (data: UpdatePromoLibraryKpiResponse, variables: UpdatePromoLibraryKpiRequest) => void;
}

const useUpdatePromoLibraryKpiMutation = ({ onSuccess }: UseUpdatePromoLibraryKpiMutationOptions = {}) => {
    const queryClient = useQueryClient();

    const { mutate, isPending } = useMutation({
        mutationFn: updateKpi,
        onSuccess: (data, variables) => {
            queryClient.invalidateQueries({ queryKey: tpoGenKeys.promoLibrary() });
            sendNotification('success', data.message ?? 'KPI updated successfully');
            onSuccess?.(data, variables);
        },
        onError: (error: any) => {
            const message =
                error?.response?.data?.detail ??
                error?.response?.data?.message ??
                error?.message ??
                'Failed to update KPI';
            sendNotification('error', message);
        },
    });

    return { mutate, isPending };
};

export default useUpdatePromoLibraryKpiMutation;
